import { render, staticRenderFns } from "./workSituation.vue?vue&type=template&id=2611ac6c&"
import script from "./workSituation.vue?vue&type=script&lang=js&"
export * from "./workSituation.vue?vue&type=script&lang=js&"
import style0 from "./workSituation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports